import { render, staticRenderFns } from "./ExtensionsSlot.vue?vue&type=template&id=4be63d3e&"
import script from "./ExtensionsSlot.vue?vue&type=script&lang=js&"
export * from "./ExtensionsSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports